module.exports = __webpack_public_path__ + "static/media/pic4.f555de2d.jpg";